import React from "react";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";
import DropdownMenu from "Components/dropdownMenu/DropdownMenu";
import t from "Utils/translation";
import formatResourceNumber from "Utils/limitsFormats";
import { displayFormattedDate } from "Utils/dateFormats";
import Tooltip from "Components/tooltip/Tooltip";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { trash, more, enable, disable } from "Icons/index";
import _ from "lodash";

import s from "./customerRow.scss";
import { withRouter } from "react-router-dom";
import qs from "query-string";
const emojiFlags = require("emoji-flags");

class CustomerRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  onDropdownOpenChange = (newVal) => {
    this.setState({ isMenuOpen: newVal });
  };

  goToDomains = () => {
    this.goToRoute(`/domains`, { customer_code: this.props.customer.code });
  };

  goToSettings = () => {
    this.goToRoute(`/customers/${this.props.customer.code}`);
  };

  goToCustomizations = () => {
    this.goToRoute(`/customers/${this.props.customer.code}/customizations`);
  };

  goToRoute = (route, query = {}) => {
    this.props.history.push({
      pathname: route,
      search: qs.stringify(query),
      state: {
        prevPagination: this.props.location.search,
      },
    });
  };

  formatEhawkScore = (score) => {
    let color;
    if (score >= 0) {
      color = "green";
    } else if (score >= -15) {
      color = "lightYellow";
    } else if (score >= -30) {
      color = "mediumYellow";
    } else if (score >= -70) {
      color = "mediumRed";
    } else if (score >= -101) {
      color = "highRed";
    }

    return <span className={s[color]}>{score}</span>;
  };

  printKind = () => {
    const { customer } = this.props;
    if (customer.is_wholesale) return "wholesale";
    if (customer.is_reseller) return "reseller";
    return "-";
  };

  render() {
    const { customer } = this.props;

    let plan;
    if (customer.plan === "paid" && customer.status_detail === "wait_pay") {
      plan = "paid (waiting payment)";
    } else {
      plan = customer.plan;
    }

    const countryInfo = customer.country ? emojiFlags[customer.country] : null;

    return (
      <tr key={customer.code}>
        <td data-label="status">
          <DomainStatusBadge status={customer.status} isHealthy statusDetail={customer.status_detail} />
        </td>
        <td data-label="plan">{plan}</td>
        <td data-label="plan" className="hideOnMobile">
          {this.printKind()}
        </td>
        <td data-label="name" className="textOverflow">
          <div className="text-[10px] italic text-[--text-a40]">{customer.email_address}</div>

          <div className="flex items-center gap-3">
            <a onClick={this.goToSettings}>{customer.fullname}</a>

            {countryInfo && (
              <Tooltip title={t("tooltip.country")} text={countryInfo.name}>
                <span className="text-base">{countryInfo.emoji}</span>
              </Tooltip>
            )}
          </div>
        </td>
        <td data-label="ehawk">{this.formatEhawkScore(customer.trustworthiness)}</td>
        <td data-label="domains" className="hideOnMobile">
          <a onClick={this.goToDomains}>{formatResourceNumber(customer.domains, customer.max_domains)}</a>
        </td>
        <td data-label="8gb" className="hideOnMobile">
          {formatResourceNumber(customer.email_accounts_8gb, customer.max_email_accounts)}
        </td>
        <td data-label="25gb" className="hideOnMobile">
          {formatResourceNumber(customer.email_accounts_25gb, customer.max_email_accounts_25gb)}
        </td>
        <td data-label="50gb" className="hideOnMobile">
          {formatResourceNumber(customer.email_accounts_50gb, customer.max_email_accounts_50gb)}
        </td>
        <td data-label="100gb" className="hideOnMobile">
          {formatResourceNumber(customer.email_accounts_100gb, customer.max_email_accounts_100gb)}
        </td>
        <td data-label="archive" className="hideOnMobile">
          {formatResourceNumber(customer.email_accounts_archive, customer.max_email_accounts_archive)}
        </td>
        <td data-label="customizations" className="hideOnMobile">
          <a onClick={this.goToCustomizations}>{customer.customizations !== 0 ? customer.customizations : "-"}</a>
        </td>
        <td data-label="creato" className="hideOnMobile">
          {displayFormattedDate(customer.created_at, false)}
        </td>
        <td data-label="scadenza" className="hideOnMobile">
          {displayFormattedDate(customer.expiration, false)}
        </td>
        <td data-label="actions">
          {customer.status !== "updating" && (
            <DropdownMenu
              isOpen={this.state.isMenuOpen}
              onOpenChange={this.onDropdownOpenChange}
              actions={[
                {
                  isHidden: customer.status !== "enabled",
                  onClick: () => this.props.changeCustomerStatus(customer.code, "disabled"),
                  icon: disable,
                  label: t("ddMenu.disable"),
                },
                {
                  isHidden: customer.status !== "disabled",
                  onClick: () => this.props.changeCustomerStatus(customer.code, "enabled"),
                  icon: enable,
                  label: t("ddMenu.enable"),
                },
                {
                  onClick: () => this.props.deleteCustomer(customer),
                  icon: trash,
                  label: t("ddMenu.delete"),
                },
              ]}
            >
              <ButtonIcon icon={more} />
            </DropdownMenu>
          )}
        </td>
      </tr>
    );
  }
}

export default withRouter(CustomerRow);
